import type { BasketModel } from '../../../components/Basket/types/models'

declare global {
  interface Window {
    klaviyo?: {
      track: (eventName: string, properties?: Record<string, unknown>) => void;
      identify: (properties: Record<string, unknown>) => void;
    }
  }
}

export type StartedCheckoutPayload = {
  $event_id: string;
  $value: number;
  basket_id: number;
  total_inc_vat: number;
  total_ex_vat: number;
  items: Array<{
    basket_item_id: number;
    product_id: number;
    name: string;
    sku: string;
    quantity: number;
    product_price_inc_vat: number;
    product_price_ex_vat: number;
  }>
}

export const buildStartedCheckoutPayload = (basket: BasketModel): StartedCheckoutPayload => {
  const unixTime = Math.floor(Date.now() / 1000)

  return {
    $event_id: `${basket.id}_${unixTime}`,
    $value: Number(basket.total_inc_tax),
    basket_id: basket.id,
    total_inc_vat: Number(basket.total_inc_tax),
    total_ex_vat: Number(basket.total_ex_tax),
    items: basket.basket_items.map((item) => ({
      basket_item_id: item.id,
      product_id: item.product.id,
      name: item.product_name,
      sku: item.product.sku,
      quantity: item.quantity,
      product_price_inc_vat: Number(item.product_price_inc_vat),
      product_price_ex_vat: Number(item.product_price_ex_vat)
    }))
  }
}

export const trackKlaviyoStartedCheckout = (basket: BasketModel): void => {
  if (typeof window.klaviyo === 'undefined') return

  window.klaviyo.track('Started Checkout', buildStartedCheckoutPayload(basket))
}
